module.exports = function(hljs) {
    return {
        disableAutodetect: true
    };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/highlight.js/lib/languages/plaintext.js
// module id = 2RAr
// module chunks = 0